import { createContext } from 'react';

const IndexData = createContext({
  data: {}
});

export { IndexData };
